import { useDeleteAiConfigurationMutation } from '@lokalise/shared'
import { useCallback } from 'react'
import {
  appHttpClient,
  authenticatedPublicApiHeaderBuilder,
  getTeamIdFromSession,
} from '../utils/api'

type UseDeleteProfileProps = {
  onSuccess: () => void
  onError: (error: unknown) => void
}

type DeleteProfileProps = {
  profileId: string
}

export const useDeleteProfile = ({ onSuccess, onError }: UseDeleteProfileProps) => {
  const teamId = getTeamIdFromSession()

  const { mutateAsync: deleteAiConfig, isPending: isDeletingAiConfig } =
    useDeleteAiConfigurationMutation(appHttpClient, authenticatedPublicApiHeaderBuilder, {
      onSuccess,
      onError,
    })

  const deleteProfile = useCallback(
    ({ profileId }: DeleteProfileProps) => deleteAiConfig({ teamId, configurationId: profileId }),
    [deleteAiConfig, teamId],
  )

  return { deleteProfile, isPending: isDeletingAiConfig }
}
